import {BaseComponent} from "../../Library/BaseComponent";
import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";
import {ActivatedRoute, Router} from "@angular/router";
import {MasterDataService} from "../../Services/MasterDataService";
import {RecurrenceQuery} from "../../Models/RequestModels";
import {GenericMaster_String} from "../../Models/GlobalEntities";
import {ListResponse} from "../../Models/ResponseModels";
import {RecurrenceConsoleService} from "../../Services/RecurrenceConsoleService";
import {untilDestroyed} from "ngx-take-until-destroy";
import {RecurrenceSort, RecurrenceSortLabel} from "../../Models/EnumModels";
import { AppSettings } from "../../Library/AppSettings";

@Component({
    selector: 'RecurrenceSearchResult',
    templateUrl: './RecurrenceSearchResult.html'
})
export class RecurrenceSearchResult extends BaseComponent implements OnInit, OnDestroy {

    @Input() RequestModel: RecurrenceQuery;
    @Input() HideTotalPages = false;
    @Output() onSelected = new EventEmitter();
    ResponseModel: ListResponse;
    SortParams: Array<GenericMaster_String>;
    SelectedSort = '';
    AppSettings = AppSettings;

    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
        public route: ActivatedRoute,
        public router: Router,
        public masterService: MasterDataService,
        public recurrenceService: RecurrenceConsoleService
    ) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.InitSortParams();
        this.recurrenceService.RecurrenceDeleted.pipe(
            untilDestroyed(this)
        ).subscribe((data) => {
            this.OnRowDeleted(data);
        });
    }

    ngOnDestroy() {
    }

    private InitSortParams() {
        this.SortParams = [
            {
                Id: RecurrenceSort.CreatedOnAsc,
                Name: RecurrenceSortLabel.CreatedOnAsc
            },
            {
                Id: RecurrenceSort.CreatedOnDesc,
                Name: RecurrenceSortLabel.CreatedOnDesc
            },
            {
                Id: RecurrenceSort.LastUpdateTimeAsc,
                Name: RecurrenceSortLabel.LastUpdateTimeAsc
            },
            {
                Id: RecurrenceSort.LastUpdateTimeDesc,
                Name: RecurrenceSortLabel.LastUpdateTimeDesc
            },
            // {
            //     Id: RecurrenceSort.StartDateTimeAsc,
            //     Name: RecurrenceSortLabel.StartDateTimeAsc
            // },
            // {
            //     Id: RecurrenceSort.StartDateTimeDesc,
            //     Name: RecurrenceSortLabel.StartDateTimeDesc
            // },
            // {
            //     Id: RecurrenceSort.EndDateTimeAsc,
            //     Name: RecurrenceSortLabel.EndDateTimeAsc
            // },
            // {
            //     Id: RecurrenceSort.EndDateTimeDesc,
            //     Name: RecurrenceSortLabel.EndDateTimeDesc
            // },
            // {
            //     Id: RecurrenceSort.ClosedDateTimeAsc,
            //     Name: RecurrenceSortLabel.ClosedDateTimeAsc
            // },
            // {
            //     Id: RecurrenceSort.ClosedDateTimeDesc,
            //     Name: RecurrenceSortLabel.ClosedDateTimeDesc
            // },
            {
                Id: RecurrenceSort.ReopenDateTimeAsc,
                Name: RecurrenceSortLabel.ReopenDateTimeAsc
            },
            {
                Id: RecurrenceSort.ReopenDateTimeDesc,
                Name: RecurrenceSortLabel.ReopenDateTimeDesc
            },
        ];
        this.SelectedSort = '';
    }

    @Input() Show() {
        this.SetData();
    }

    // Fetch Data
    private SetData() {
        if (!this.RequestModel) {
            return;
        }

        this.IsSubmitting = true;
        this.recurrenceService.Recurrence_Query(this.RequestModel)
            .then(data => {
                this.ResponseModel = data;
                this.RequestModel.PageNumber = data && data.CurrentPage || this.RequestModel.PageNumber;
                this.IsSubmitting = false;
            })
            .catch(reason => {
                this.IsSubmitting = false;
            })

    }

    // Row Selection
    OnRowSelected(row) {
        if (row && this.recurrenceService.SelectedRecurrence && row.RecurrenceId === this.recurrenceService.SelectedRecurrence.RecurrenceId) {
            return;
        }
        this.recurrenceService.SelectedRecurrence = row;
        this.onSelected.emit(row);
    }

    // Pagination
    OnPageChange() {
        this.SetData();
    }

    // Sorting
    OnSortSelected(row: GenericMaster_String) {
        this.RequestModel.OrderBy = row.Id as RecurrenceSort;
        this.SelectedSort = row.Name;
        this.SetData();
    }

    private OnRowDeleted(data) {
        this.ResponseModel = this.recurrenceService.RecurrenceDeleteForResults(this.ResponseModel, data);
    }
}
